module.exports = __webpack_public_path__ + "img/models.8fda684d.jpg";